import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { useMediaQuery, useTheme } from '@material-ui/core'
import { CLOUDINARY_NAME } from '../../constants'
import { Image, Transformation } from 'cloudinary-react'

const useStyles = makeStyles((theme) => ({
    inThePressHeading: {
        textTransform: 'uppercase',
        textAlign: 'center',
        fontSize: '1.2rem',
        letterSpacing: 1.5,
        marginTop: 10,
        marginBottom: 10,
        [theme.breakpoints.up('md')]: {
            marginTop: '2.5rem',
            marginBottom: 0,
        },
    },
    pressLogos: {
        padding: '0 1rem',
        justifyContent: 'center',
        textAlign: 'center',
        '& img': {
            maxHeight: '100px',
            maxWidth: '100%',
        },
        [theme.breakpoints.up('md')]: {
            padding: '0 3rem',
        },
    },
    inline: {
        display: 'inline !important',
    },
    lazyLoaded: {
        opacity: 1,
        transition: 'opacity 300ms',
    },
    gridItem: {
        width: '25%',
    },
}))

const pressImages = [
    {
        cloudinaryId: 'GCG/assets/gma_ekqece',
        alt: 'Gift Card Granny on Good Morning America',
        url: 'https://www.goodmorningamerica.com/living/story/top-tips-make-holiday-returns-breeze-score-deeper-60016667',
        hideOnMobile: true,
        sm: 4,
        md: 3,
        testId: 'gma-logo-link',
    },
    {
        cloudinaryId: 'GCG/assets/oprah_kqgr38',
        alt: 'Gift Card Granny in Oprah Magazine',
        url: 'http://www.oprah.com/money/4-ways-to-get-a-bigger-shopping-discount',
        hideOnMobile: false,
        sm: 4,
        md: 3,
        testId: 'oprah-logo-link',
    },
    {
        cloudinaryId: 'GCG/assets/forbes_drwv4t',
        alt: 'Gift Card Granny in Forbes',
        url: 'https://www.forbes.com/sites/zackfriedman/2017/01/10/gift-cards-cash/#1d0d47d65943',
        hideOnMobile: false,
        sm: 4,
        md: 3,
        testId: 'forbes-logo-link',
    },
    {
        cloudinaryId: 'GCG/assets/cnbc_a6co33',
        alt: 'Gift Card Granny on CNBC',
        url: 'https://www.cnbc.com/2016/11/23/gift-card-exchanges-can-save-you-up-to-35-percent.html',
        hideOnMobile: false,
        sm: 4,
        md: 3,
        testId: 'cnbc-logo-link',
    },
    {
        cloudinaryId: 'GCG/assets/cbs-new-york_nwgfwh',
        alt: 'Gift Card Granny on CBS New York',
        url: 'https://newyork.cbslocal.com/2020/05/05/coronavirus-pandemic-means-a-different-kind-of-mothers-day-celebration/',
        hideOnMobile: false,
        sm: 4,
        md: 2,
        testId: 'cbs-newyork-logo-link',
    },
    {
        cloudinaryId: 'GCG/assets/cheddar_eyoqs7',
        alt: 'Gift Card Granny on Cheddar TV',
        url: 'https://cheddar.com/media/how-to-avoid-coronavirus-scams',
        hideOnMobile: false,
        sm: 4,
        md: 2,
        testId: 'cheddartv-logo-link',
    },
    {
        cloudinaryId: 'GCG/assets/nbc-news_oktee9',
        alt: 'Gift Card Granny on NBC News',
        url: 'https://www.nbcnews.com/business/consumer/retailers-are-making-it-easier-you-return-gifts-buy-more-n702561',
        hideOnMobile: false,
        sm: 4,
        md: 2,
        testId: 'nbc-news-logo-link',
    },
    {
        cloudinaryId: 'GCG/assets/us-news-world-report_n1wswo',
        alt: 'Gift Card Granny in U.S. News',
        url: 'https://money.usnews.com/money/personal-finance/saving-and-budgeting/articles/throwing-a-baby-shower-on-a-budget',
        hideOnMobile: false,
        sm: 4,
        md: 2,
        testId: 'us-news-logo-link',
    },
    {
        cloudinaryId: 'GCG/assets/wgn-america_jxpsh5',
        alt: 'Gift Card Granny on WGN America',
        url: 'https://wgntv.com/midday-news/midday-fix-tips-to-save-you-money-on-back-to-school-shopping/',
        hideOnMobile: true,
        sm: 4,
        md: 2,
        testId: 'wgn-america-logo-link',
    },
]

const InThePressSection = () => {
    const classes = useStyles()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'), {
        defaultMatches: true,
    })
    const pressImageWidth = isMobile ? 82 : 169
    const pressImageHeight = isMobile ? 48 : 100
    return (
        <>
            <Typography variant="h3" className={classes.inThePressHeading}>
                Gift Card Granny - In The Press
            </Typography>
            <Grid container className={`${classes.pressLogos}`}>
                {pressImages.map((pressImage, index) => {
                    return (
                        <Grid
                            item
                            sm={pressImage.sm}
                            md={pressImage.md}
                            className={classes.gridItem}
                            key={index}
                        >
                            <a
                                href={pressImage.url}
                                rel="noreferrer noopener"
                                target="_blank"
                                data-testid={pressImage.testId}
                            >
                                <Image
                                    cloudName={CLOUDINARY_NAME}
                                    publicId={pressImage.cloudinaryId}
                                    className={`${classes.inline} ${classes.lazyLoaded}`}
                                    alt={pressImage.alt}
                                    loading="lazy"
                                    width={pressImageWidth}
                                    height={pressImageHeight}
                                >
                                    <Transformation
                                        width="auto"
                                        crop="scale"
                                        fetchFormat="auto"
                                    />
                                </Image>
                            </a>
                        </Grid>
                    )
                })}
            </Grid>
        </>
    )
}

export default InThePressSection
